module.exports = __webpack_public_path__ + "static/media/08_machine_log.fd9de303.jpg";